import React, { useState } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import {
  HistoryIcon,
  Iicon,
  LockGreyIcon,
  RightArrow,
  TableMoreDetails,
  commentIcon,
  grayViewIcon,
  invoiceDownLoadIcon,
  tableEditIcon,
} from "../../../assets/images";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import {
  GetAllExpensesInvoicesListType
} from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import {
  formatDate,
  formateDateWithTime,
} from "../../../utils/commonFunctions";
import Avatar from "../../commons/CircularAvatar/CircularAvatar";
import "./styles.scss";
import { PaperClipIcon } from "../../Icon";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { SendInvoiceEmailData } from "./ExpenseInvoicesList";

type AppProps = {
  tableHeader: TableHeadersType[];
  data: GetAllExpensesInvoicesListType[] | [];
  handleRedirectToEditForm: (data: GetAllExpensesInvoicesListType) => void;
  handleRedirectToCopyForm: (data: GetAllExpensesInvoicesListType) => void;
  deleteInvoice?: (invoice_id: number) => void;
  loginData: LoginResponseType;
  handleShowConfirmationModal: (id: number) => void;
  isEditExpensePresent?: boolean;
  isAddExpensePresent?: boolean;
  isExpenseListCommentPresent?: boolean;
  isViewExpensesInvoicePresent?: boolean;
  currencySign: string | undefined;
  isExpenseHistory: boolean;
  toggleInvoiceHistory: (type: string, id?: number) => void;
  handleToggleInvoiceCommentsModal?: () => void;
  handleSetInvoiceData: (data: any) => void;
  lockedExpensesEntriesDate: null | string;
  isDeleteExpenseEntries: boolean;
  setShowSendInvoiceEmailModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleSendInvoiceEmailData: (data: SendInvoiceEmailData) => void;
  handleCustomerSuplierDetailsData: (invoiceType: number) => void;
  togglePreviewEWayBill: (data: any) => void;
  isEWayBillPresent?: boolean;
  handleGeneratePdf: (data: any) => void;
  handleNewInvoicePdf: (data: any) => void;
  pdfFetching: boolean;
  isExpenseInvoiceDownloadPresent?: boolean;
};

const ExpenceInvoicesListTableData = ({
  data,
  tableHeader,
  handleRedirectToEditForm,
  deleteInvoice,
  handleShowConfirmationModal,
  isEditExpensePresent,
  isExpenseListCommentPresent,
  handleToggleInvoiceCommentsModal,
  handleSetInvoiceData,
  isAddExpensePresent,
  isExpenseHistory,
  isViewExpensesInvoicePresent,
  handleRedirectToCopyForm,
  currencySign,
  lockedExpensesEntriesDate,
  toggleInvoiceHistory,
  isDeleteExpenseEntries,
  handleCustomerSuplierDetailsData,
  togglePreviewEWayBill,
  isEWayBillPresent,
  handleGeneratePdf,
  handleNewInvoicePdf,
  pdfFetching,
  isExpenseInvoiceDownloadPresent,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);
  const [sameIndex, setSameIndex] = useState<any>("-2");

  const renderTableData = () => {
    const handleMoreDataOpen = (data: any, index: any) => {
      setSameIndex(index);
      setToggle(!toggle);
    };

    const renderEditInvoiceToolTip = (props: any) => {
      return (
        <Tooltip id="button-view-open-item" {...props}>
          Edit Invoice
        </Tooltip>
      );
    };

    const renderLockInvoiceToolTip = (props: any) => {
      return (
        <Tooltip id="button-view-open-item" {...props}>
          Invoice Locked
        </Tooltip>
      );
    };

    const renderMoreDetailsInvoiceToolTip = (props: any) => {
      return (
        <Tooltip id="button-view-open-item" {...props}>
          More Details
        </Tooltip>
      );
    };
    const renderDownloadInvoiceToolTip = (props: any) => {
      return (
        <Tooltip id="button-view-open-item" {...props}>
          Download Invoice
        </Tooltip>
      );
    };
    const finalTableData = data?.length
      ? data?.map((dataItem: any, index: number) => {
          let finalName = !dataItem?.first_name?.length
            ? `${dataItem?.company_name?.slice(0, 25)}...`
            : `${dataItem.first_name} ${dataItem?.last_name}`;
          let splitedLockedEntries: string | string[] =
            lockedExpensesEntriesDate
              ? lockedExpensesEntriesDate?.split("-")
              : "";
          let splitedInvoiceDate: string[] = formatDate(
            dataItem?.voucher_invoice_date
          )?.split("-");

          let lockedDate = new Date(
            +splitedLockedEntries[2],
            +splitedLockedEntries[1] - 1,
            +splitedLockedEntries[0]
          );
          let itemDate = new Date(
            +splitedInvoiceDate[2],
            +splitedInvoiceDate[1] - 1,
            +splitedInvoiceDate[0]
          );
          return (
            <tr key={dataItem?.id}>
              {tableHeader?.length &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header.value === "supplier_name") {
                    return (
                      <td style={{ width: "230px" }}>
                        {dataItem?.supplier_name?.legal_name}
                        {
                          <img
                            className="ml-2 pointer"
                            src={Iicon}
                            alt="EyeIcon"
                            onClick={() =>
                              handleCustomerSuplierDetailsData?.(
                                dataItem?.supplier_name?.ledger_id
                              )
                            }
                          />
                        }
                        {dataItem?.supplier_name?.trade_name && (
                          <>
                          <br />
                          <span style={{
                            color: "rgb(103, 100, 100)",
                            fontSize: "13px",
                          }}>
                              {dataItem?.supplier_name?.trade_name}
                          </span>
                          </>
                        )}
                        <br></br>
                        {dataItem?.invoice_category === 1 &&
                        dataItem?.document_type ? (
                          <div
                            className="invoice-category mt-2"
                            style={{ background: "#d4edf0", color: "#2d8589" }}
                          >
                            {dataItem?.document_type?.label}
                          </div>
                        ) : (
                          ""
                        )}
                        {dataItem?.invoice_category === 2 ? (
                          <div
                            className="invoice-category mt-2"
                            style={{ background: "#e3efff", color: "#2080f6" }}
                          >
                            {" "}
                            Purchase Order
                          </div>
                        ) : (
                          ""
                        )}
                        {dataItem?.invoice_category === 3 ? (
                          <div
                            className="mt-2"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "left",
                            }}
                          >
                            <div
                              className="invoice-category"
                              style={{
                                background: "#e3efff",
                                color: "#2080f6",
                              }}
                            >
                              Purchase Order
                            </div>
                            <div>
                              <img
                                style={{ width: "22px" }}
                                src={RightArrow}
                                alt="arrow"
                              />
                            </div>
                            <div
                              className="invoice-category"
                              style={{
                                background: "#d4edf0",
                                color: "#2d8589",
                              }}
                            >
                              {dataItem?.document_type?.label ===
                              "Tax Invoice (RCM applicable)" ? (
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 250 }}
                                  overlay={
                                    <Tooltip id="button-view-open-item">
                                      {dataItem?.document_type?.label}
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    {dataItem?.document_type?.label?.slice(
                                      0,
                                      11
                                    ) + "..."}
                                  </span>
                                </OverlayTrigger>
                              ) : (
                                dataItem?.document_type?.label
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  } else if (header.value === "voucher_invoice_number") {
                    return (
                      <td style={{ width: "140px", textAlign: "center" }}>
                        {dataItem?.voucher_invoice_number}
                      </td>
                    );
                  } else if (header.value === "created_at") {
                    return (
                      <td style={{ width: "140px", textAlign: "center" }}>
                        {formatDate(dataItem?.created_at)}
                      </td>
                    );
                  } else if (header.value === "voucher_invoice_date") {
                    return (
                      <td style={{ width: "150px" }}>
                        {formatDate(dataItem?.voucher_invoice_date)}
                      </td>
                    );
                  } else if (header.value === "net_amount") {
                    return (
                      <td style={{ maxWidth: "150px" }}>
                        {dataItem?.net_amount ? currencySign : "NA"}
                        {dataItem?.net_amount
                          ? dataItem?.net_amount?.toString()?.split(".")[1]
                              ?.length > 4
                            ? dataItem?.net_amount?.toFixed(4)
                            : dataItem?.net_amount
                          : dataItem?.net_amount}
                      </td>
                    );
                  } else if (header.value === "updated_at") {
                    return (
                      <td style={{ width: "150px" }}>
                        {" "}
                        {formateDateWithTime(dataItem?.updated_at)}
                      </td>
                    );
                  } else if (header.value === "upload") {
                    return !!dataItem?.upload?.length ? (
                      <td
                        style={{ width: "50px" }}
                        className="position-relative"
                      >
                        <PaperClipIcon />
                        <span className="badge count-badge">
                          {dataItem?.upload?.length}
                        </span>
                      </td>
                    ) : (
                      <td style={{ width: "50px" }}> --/-- </td>
                    );
                  } else if (header.value === "net_amount") {
                    return (
                      <td style={{ width: "170px", textAlign: "center" }}>
                        {" "}
                        {dataItem?.net_amount}
                      </td>
                    );
                  } else if (header.value === "payment_status") {
                    return (
                      <td style={{ minWidth: "160px", textAlign: "center" }}>
                        <span>
                          {dataItem?.payment_status === "Paid" && (
                            <span className="credit">Paid</span>
                          )}
                          {dataItem?.payment_status === "Purchase Order" && (
                            <span className="estimatePurchase">
                              Purchase Order
                            </span>
                          )}
                          {dataItem?.payment_status === "Pending" && (
                            <span className="debit">Pending</span>
                          )}
                          {dataItem?.payment_status === "Incomplete" && (
                            <span className="status-incomplete">
                              Partial Paid
                            </span>
                          )}
                        </span>
                      </td>
                    );
                  } else if (header.value === "company_name") {
                    return (
                      <td style={{ textAlign: "center" }}>
                        <div className="d-flex flex-column">
                          {finalName}
                          <span className="due-date-text">
                            {formateDateWithTime(dataItem?.updated_at)}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (header.value === "approved_by") {
                    return (
                      <td style={{ textAlign: "center" }}>
                        <div className="d-flex">
                          {dataItem?.approval_details?.length > 0 ? (
                            dataItem?.approval_details?.map(
                              (profileData: any) => {
                                let fullName =
                                  profileData?.first_name +
                                  " " +
                                  profileData?.last_name;

                                return (
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={
                                      <Tooltip id="button-view-open-item">
                                        {fullName}
                                        <br></br>
                                        approved on{" "}
                                        {formateDateWithTime(
                                          profileData?.approved_at
                                        )}
                                      </Tooltip>
                                    }
                                  >
                                    <span style={{ cursor: "pointer" }}>
                                      <Avatar
                                        name={fullName}
                                        image={
                                          profileData?.profile_pic?.file_url
                                        }
                                      />
                                    </span>
                                  </OverlayTrigger>
                                );
                              }
                            )
                          ) : (
                            <span>--/--</span>
                          )}
                        </div>
                      </td>
                    );
                  } else {
                    return <td> --/-- </td>;
                  }
                })}
              <td style={{ width: "120px", textAlign: "center" }}>
                {isEditExpensePresent &&
                  (isViewExpensesInvoicePresent || isEditExpensePresent) && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        (lockedExpensesEntriesDate && itemDate <= lockedDate) ||
                        dataItem?.e_way_bill_status === 1 ||
                        dataItem?.e_way_bill_status === 3
                          ? renderLockInvoiceToolTip
                          : renderEditInvoiceToolTip
                      }
                    >
                      {(lockedExpensesEntriesDate && itemDate <= lockedDate) ||
                      dataItem?.e_way_bill_status === 1 ||
                      dataItem?.e_way_bill_status === 3 ? (
                        <span className="d-inline-block pointer">
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <img src={LockGreyIcon} alt="lock" />
                          </div>
                        </span>
                      ) : (
                        <span
                          className="d-inline-block pointer"
                          onClick={() => handleRedirectToEditForm?.(dataItem)}
                        >
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <img src={tableEditIcon} alt="edit" />
                          </div>
                        </span>
                      )}
                    </OverlayTrigger>
                  )}

                {isExpenseHistory ? (
                  <span>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="history-tooltip">Invoice Audit</Tooltip>
                      }
                    >
                      <span className="d-inline-block pointer">
                        <div
                          style={{
                            color: "#d43",
                            fontSize: 20,
                            width: "30px",
                          }}
                          onClick={() =>
                            toggleInvoiceHistory("open", dataItem.id)
                          }
                        >
                          <img src={HistoryIcon} alt="" />
                        </div>
                      </span>
                    </OverlayTrigger>
                  </span>
                ) : null}

                {isViewExpensesInvoicePresent && !isEditExpensePresent && (
                  <span
                    className="d-inline-block pointer"
                    onClick={
                      (lockedExpensesEntriesDate && itemDate <= lockedDate) ||
                      dataItem?.e_way_bill_status === 1 ||
                      dataItem?.e_way_bill_status === 3
                        ? () => {}
                        : () => handleRedirectToEditForm?.(dataItem)
                    }
                  >
                    <div>
                      {(lockedExpensesEntriesDate && itemDate <= lockedDate) ||
                      dataItem?.e_way_bill_status === 1 ||
                      dataItem?.e_way_bill_status === 3 ? (
                        <img src={LockGreyIcon} alt="lock" />
                      ) : (
                        <img src={grayViewIcon} alt="view" />
                      )}
                    </div>
                  </span>
                )}

                {isExpenseInvoiceDownloadPresent && (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={renderDownloadInvoiceToolTip}
                  >
                    <span
                      className="d-inline-block pointer ml-2"
                      onClick={() => {
                        handleGeneratePdf?.(dataItem);
                        handleNewInvoicePdf(dataItem);
                      }}
                    >
                      <img src={invoiceDownLoadIcon} alt="download invoice" />
                    </span>
                  </OverlayTrigger>
                )}
               
                <span className="d-inline-block pointer ml-2">
                  {isExpenseListCommentPresent && (
                    <>
                      <div
                        className="position-relative"
                        onClick={() => {
                          handleToggleInvoiceCommentsModal?.();
                          handleSetInvoiceData(dataItem);
                        }}
                      >
                        {dataItem?.comment_count != 0 && (
                          <span className="jobs-link-count">
                            {dataItem?.comment_count}
                          </span>
                        )}
                        <img src={commentIcon} alt="comment" />
                      </div>
                    </>
                  )}
                </span>

                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 250 }}
                  overlay={renderMoreDetailsInvoiceToolTip}
                >
                  <span
                    style={{ cursor: "pointer", width: "21px", height: "25px" }}
                    className="ml-2"
                    onClick={() => handleMoreDataOpen(dataItem, index)}
                  >
                    <img
                      style={{ width: "inherit" }}
                      src={TableMoreDetails}
                      alt="more"
                    />
                  </span>
                </OverlayTrigger>
                {+sameIndex === index && (
                  <ButtonDropdown
                    // color="#bfcbe1"
                    isOpen={toggle}
                    toggle={() => {
                      setToggle(!toggle);
                    }}
                  >
                    {/* {isOpen()} */}
                    <DropdownToggle
                      caret
                      color="secondary"
                      style={{
                        background: "none",
                        color: "none",
                        opacity: "1",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                       
                      </div>
                    </DropdownToggle>
                    <DropdownMenu
                      right
                      style={{ marginRight: "-20px", marginTop: "-15px" }}
                    >
                      <div
                        className="p-3 download-dropdown"
                        style={{ minWidth: "200px", display: "inline-block" }}
                      >
                        {isEWayBillPresent && (
                          <span
                            className="radio-container-vertical"
                            onClick={() => togglePreviewEWayBill(dataItem)}
                          >
                            View E-Way Bill
                          </span>
                        )}

                        {deleteInvoice &&
                          ((((lockedExpensesEntriesDate &&
                            itemDate <= lockedDate) ||
                          dataItem?.e_way_bill_status === 1 ||
                          dataItem?.e_way_bill_status ===
                            3) || (dataItem?.credit_note_mapping!==undefined ? +dataItem?.credit_note_mapping>0 : false)) ? null : isDeleteExpenseEntries ? (
                            <span
                              onClick={() =>
                                handleShowConfirmationModal(dataItem.id)
                              }
                            >
                              <span className="radio-container-vertical">
                                Delete Invoice
                              </span>
                            </span>
                          ) : null)}
                        {(isAddExpensePresent && (dataItem?.credit_note_mapping !==undefined ? +dataItem?.credit_note_mapping===0 : true)) ? (
                          <span
                            onClick={() => handleRedirectToCopyForm?.(dataItem)}
                            className="radio-container-vertical"
                          >
                            Duplicate Invoice
                          </span>
                        ) : null}
                        {(lockedExpensesEntriesDate &&
                          itemDate <= lockedDate) ||
                        dataItem?.e_way_bill_status === 1 ||
                        dataItem?.e_way_bill_status === 3 ? (
                          <span
                            onClick={() => handleRedirectToEditForm?.(dataItem)}
                            className="radio-container-vertical"
                          >
                            View Invoice
                          </span>
                        ) : null}
                        {/* Future Use */}
                        {/* <span onClick={() => {
                    handleSendInvoiceEmailData?.({
                      ledgerId:dataItem?.supplier_name?.ledger_id,
                      invoiceId:dataItem?.id
                    });
                    setShowSendInvoiceEmailModal(true)
                    }} className="radio-container-vertical">Send invoice email</span> */}
                      </div>
                    </DropdownMenu>
                  </ButtonDropdown>
                )}
              </td>
            </tr>
          );
        })
      : "";

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default ExpenceInvoicesListTableData;
